module.exports = __webpack_public_path__ + "ac6e1c66067c7a410ae0415e9045ae9a.png";